var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewerRoleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7284 8.90433C13.7113 2.30994 6.28863 2.30986 2.27154 8.90424C1.86261 9.57549 1.86261 10.4247 2.27154 11.0959C6.28863 17.6903 13.7113 17.6904 17.7284 11.0961C18.1373 10.4247 18.1373 9.57558 17.7284 8.90433Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0341 8.4875L10.4533 6.97762C10.3812 6.79019 10.2012 6.6665 10.0003 6.6665C9.79949 6.6665 9.61941 6.79019 9.54733 6.97762L8.96658 8.4875C8.88199 8.70759 8.70808 8.8815 8.48799 8.96609L6.97811 9.54684C6.79068 9.61892 6.66699 9.799 6.66699 9.99984C6.66699 10.2007 6.79068 10.3808 6.97811 10.4528L8.48799 11.0336C8.70808 11.1182 8.88199 11.2921 8.96658 11.5122L9.54733 13.0221C9.61941 13.2095 9.79949 13.3332 10.0003 13.3332C10.2012 13.3332 10.3812 13.2095 10.4533 13.0221L11.0341 11.5122C11.1187 11.2921 11.2926 11.1182 11.5127 11.0336L13.0226 10.4528C13.21 10.3808 13.3337 10.2007 13.3337 9.99984C13.3337 9.799 13.21 9.61892 13.0226 9.54684L11.5127 8.96609C11.2926 8.8815 11.1187 8.70759 11.0341 8.4875Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewerRoleIcon);
export default __webpack_public_path__ + "static/media/viewer-role-icon.5c4988c95a742ea5fecc87c13d3eeed1.svg";
export { ForwardRef as ReactComponent };